import { types, async } from "../utils/type-creator";

export default types(
  [...async("GET_SUB_OPTIONS"), ...async("GET_OPTIONS"), ...async("REGISTER")],
  "DEPARTMENTS"
);
